<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-hover v-if="hoverable" v-slot="{ hover }">
        <v-btn
          :class="cssClass"
          icon
          :x-small="size == sizes[0]"
          :small="size == sizes[1]"
          :large="size == sizes[2]"
          :x-large="size == sizes[3]"
          :color="hover ? hoverColor : clickCount ==1 ? 'red':(isSelected || clickCount ==2)?'green':''"
          @click="delegateAction"
          v-bind="attrs"
          v-on="on"
          :disabled="disabled"
        >
          <v-icon>{{icon}}</v-icon>
        </v-btn>
      </v-hover>

      <v-btn
        v-else
        :x-small="size == sizes[0]"
        :small="size == sizes[1]"
        :large="size == sizes[2]"
        :x-large="size == sizes[3]"
        icon
        :color="color"
        @click="delegateAction"
        v-bind="attrs"
        v-on="on"
        :disabled="disabled"
      >
        <v-icon>{{icon}}</v-icon>
      </v-btn>
    </template>
    <span>{{tooltip}}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "ConfirmActionBtn",
  props: {
    
    size: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    hoverable: {
      type: Boolean,
      required: true,
    },
    color: {
      type: String,
    },
    hoverColor: {
      type: String,
    },
    action: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      required: true,
    },
    invoice: {
      type: Object,
    },
    cssClass: {
      type: String,
      required: false
    }
  },
  data(){
    return {
      clickCount: 0,
      selected: false,
      sizes: [
        'x-small',
        'small',
        'large',
        'x-large'
      ],
    };
  },
  computed: {
    isSelected: {
      get: function(){        
        return this.selected;
      },
      set: function(newValue){
        this.selected = newValue;
      }
    }
  },
  methods: {
    delegateAction() {
      const invoiceID = this.$props.invoice ? this.$props.invoice.id:null;
      this.clickCount += 1;
      
      if(this.clickCount == 1) 
        this.$emit("firstClick", {...this.$props.invoiceID});
      else if (this.clickCount == 2) {
        this.$emit("btnAction", invoiceID);
        this.isSelected = true;
        this.clickCount = 0;
      }
    },
  },
};
</script>